import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/contact/contact-page.tsx");
